/**
 * Build a locale-aware path.
 * - en-us and undefined → no prefix (root)
 * - all other locales   → /{locale}{path}
 *
 * Examples:
 *   localePath('es-mx', '/debt-snowball-calculator/') → '/es-mx/debt-snowball-calculator/'
 *   localePath('en-us', '/about')                     → '/about'
 *   localePath(undefined, '/faq')                     → '/faq'
 */
export function localePath(locale, path) {
  const prefix = (!locale || locale === 'en-us') ? '' : `/${locale}`;
  return `${prefix}${path}`;
}
